import {useContext, useEffect, useState} from "react";
import {InputTextArea, InputTextCustom, SearchCustom} from "../../components";
import {AssuntoApi, SetorApi, UserApi, CiApi} from "../../apis";
import {FaEnvelopeOpenText, FaTimes} from "react-icons/fa";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import Logo from "../../assets/img/logo-h.png";
import {useNavigate} from "react-router";

export const CiCreate = () => {
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const [setor, setSetor] = useState('');
  const [setorNome, setSetorNome] = useState('');
  const [funcionario, setFuncionario] = useState('');
  const [funcionarioNome, setFuncionarioNome] = useState('');
  const [assunto, setAssunto] = useState('');
  const [assuntoNome, setAssuntoNome] = useState('');
  const [listaSetor, setListaSetor] = useState([]);
  const [listaFuncionario, setListaFuncionario] = useState([]);
  const [listaAssunto, setListaAssunto] = useState([]);
  const [texto, setTexto] = useState('');
  const [errorTexto, setErrorTexto] = useState(false);
  const [helperTexto, setHelperTexto] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [errorTitulo, setErrorTitulo] = useState(false);
  const [helperTitulo, setHelperTitulo] = useState(false);
  const {setLoading} = useContext(LoadingContext);
  const [count, setCount] = useState(0);
  const [preview, setPreview] = useState(false);
  const navigate = useNavigate();

  const data = new Date();
  const mes = ['Janeiro', 'Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const load = async () => {
    setLoading(true);
    try {
      let respostaSetor = await SetorApi.get();
      if (!respostaSetor.error) {
        setListaSetor(respostaSetor.data);
      } else {
        AddToast({texto:"Falha ao carregar setores!", tipo:"erro"});
      }
      setLoading(false);
    } catch (e) {
      AddToast({texto:e, tipo:"erro"});
      setLoading(false);
    }
    try {
      let respostaFuncionario = await UserApi.getFuncionarios(user.uuid);
      if (!respostaFuncionario.error) {
        setListaFuncionario(respostaFuncionario.data);
      } else {
        AddToast({texto:"Falha ao carregar funcionários!", tipo:"erro"});
      }
      setLoading(false);
    } catch (e) {
      AddToast({texto:e, tipo:"erro"});
      setLoading(false);
    }
    try {
      let respostaAssunto = await AssuntoApi.get();
      if (!respostaAssunto.error) {
        setListaAssunto(respostaAssunto.data);
      } else {
        AddToast({texto:"Falha ao carregar assuntos!", tipo:"erro"});
      }
      setLoading(false);
    } catch (e) {
      AddToast({texto:e, tipo:"erro"});
      setLoading(false);
    }
  }
  useEffect(() => {
    if (listaSetor.length > 0) {
      setSetor(listaSetor[0].uuid);
      setSetorNome(listaSetor[0].titulo);
    }
    }, [listaSetor]);

  useEffect(() => {
    if (listaFuncionario.length > 0) {
      setFuncionario(listaFuncionario[0].uuid);
      setFuncionarioNome(listaFuncionario[0].nome);
    }
  },[listaFuncionario]);

  useEffect(() => {
    if (listaAssunto.length > 0) {
      setAssunto(listaAssunto[0].uuid);
      setAssuntoNome(listaAssunto[0].titulo);
    }
  },[listaAssunto]);

  if (count < 1) {
    load();
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Comunicados',
        icone: <FaEnvelopeOpenText size={30}/>
      }
    );
    setCount(count + 1);
  }

  const send = async () => {
    setLoading(true);
    try {
      let respostaEnvio = await CiApi.create(user.uuid, titulo, setor, funcionario, assunto, texto);
      if (!respostaEnvio.error) {
        AddToast({texto:"Enviado!", tipo:"sucesso"});
        setLoading(false);
        setPreview(false);
        navigate(-1);
      } else {
        AddToast({texto:respostaEnvio.error, tipo:"erro"});
        setLoading(false);
        setPreview(false);
      }
    } catch (e) {
      AddToast({texto:e, tipo:"erro"});
      setLoading(false);
      setPreview(false);
    }
  }

  const validarCampos = () => {
    if (titulo === '') {
      setHelperTitulo("O campo não pode estar vazio");
      setErrorTitulo(true);
      return false;
    }

    if (texto === '') {
      setHelperTexto("O campo não pode estar vazio");
      setErrorTexto(true);
      return false;
    }

    if (setor === '') {
      AddToast({texto:"Setor não pode estar vazio", tipo:"erro"});
      return false;
    }

    if (funcionario === '') {
      AddToast({texto:"Funcionário não pode estar vazio", tipo:"erro"});
      return false;
    }

    if (assunto === '') {
      AddToast({texto:"Assunto não pode estar vazio", tipo:"erro"});
      return false;
    }
    return true;
  }

  const openPreview = () => {
    if (validarCampos()) {
      setPreview(true);
    }
  }

  return (
    <div className="form-ci">
      <div className="painel-itens">
        <h2 className="titulo" style={{marginBottom:"30px"}}>Adicionar uma Comunicação Interna</h2>
        <InputTextCustom
          label="Título:"
          value={titulo}
          onChange={(t) => setTitulo(t.target.value)}
          helperText={helperTitulo}
          error={errorTitulo}
        />
        {listaSetor.length > 0 &&
          <div className="seletor">
            <label>Setor:</label>
            <select onChange={(e) => {
              setSetor(e.target.value);
              setSetorNome(e.target.selectedOptions[0].label);
            }}>
              {listaSetor.map((item) => (
                <option key={item.uuid} value={item.uuid}>{item.titulo}</option>
              ))}
            </select>
          </div>
        }
        {listaFuncionario.length > 0 &&
          // <div className="seletor">
          //   <label>Funcionário:</label>
          //   <select onChange={(e) => {
          //     setFuncionario(e.target.value);
          //     setFuncionarioNome(e.target.selectedOptions[0].label);
          //   }}>
          //     {listaFuncionario.map((item) => (
          //       <option key={item.uuid} value={item.uuid}>{item.nome}</option>
          //     ))}
          //   </select>
          // </div>
          <SearchCustom
            label="Funcionário:"
            selected={funcionario}
            selectedName={funcionarioNome}
            itens={listaFuncionario}
            change={(uuid, nome) => {setFuncionario(uuid); setFuncionarioNome(nome)}}
            // setFuncionario={setFuncionario}
            // setFuncionarioNome={setFuncionarioNome}
          />
        }
        {listaAssunto.length > 0 &&
          <div className="seletor">
            <label>Assunto:</label>
            <select onChange={(e) => {
              setAssunto(e.target.value);
              setAssuntoNome(e.target.selectedOptions[0].label);
            }}>
              {listaAssunto.map((item) => (
                <option key={item.uuid} value={item.uuid}>{item.titulo}</option>
              ))}
            </select>
          </div>
        }
        <InputTextArea
          label="Conteúdo:"
          value={texto}
          onChange={(t) => {
            setTexto(t.target.value)
          }}
          error={errorTexto}
          helperText={helperTexto}
        />
        <div className="d-flex justify-end">
          <div className="btn btn-cancelar" onClick={() => navigate(-1)}>
            Cancelar
          </div>
          <div className="btn btn-enviar" onClick={() => openPreview()}>
            Cadastrar
          </div>
        </div>

      </div>
      {preview &&
        <div className="tela-modal-preview">
          <div className="modal">
            <div className="modal-arquivo-cabecalho">
              <div className="titulo">
                <FaEnvelopeOpenText size={30}/>
                <span>Pré-visualização</span>
              </div>
              <div className="btn-close-modal" onClick={() => {
                setPreview(false)
              }}>
                Fechar(
                <FaTimes/>
                )
              </div>
            </div>
            <div className="documento">
              <img className="logo-documento" src={Logo} alt="Logo Nunes Peixoto"/>
              <span className="titulo">Comunicação Interna</span>
              <span className="linha">Destino: <span className="valor">Departamento Pessoal / RH </span> <span style={{marginLeft: '20px'}}>Setor: <span className="valor">{setorNome}</span></span></span>
              <span className="linha" style={{display:"flex",justifyContent:"space-between"}}><span>Funcionário: <span className="valor">{funcionarioNome}</span></span> <span>Assunto: <span className="valor">{assuntoNome}</span></span></span>
              <textarea className="texto" value={texto} disabled/>
              <span className="linha">Itabaiana, <span className="valor">{data.getDate()}</span> de <span className="valor">{mes[data.getMonth()]}</span> de <span className="valor">{data.getFullYear()}</span></span>
              <span className="centro"><span className="valor">{user.nome}</span></span>
              <span className="centro">Assinatura do solicitante</span>
            </div>
            <div className="btn btn-enviar" onClick={send}>
              Cadastrar
            </div>
          </div>
        </div>
      }
    </div>
  );
}